<script lang="ts">
  import { page } from '$app/stores';
  import type { LayoutPreferenceType } from '$types/races';

  $: ({ layoutConfigStore } = $page.data);
  $: activeLayoutConfig = layoutConfigStore?.activeLayoutConfig;

  const options = new Map<keyof typeof LayoutPreferenceType, string>();
  options.set('FIXED_WIN', 'Fixed Win');
  options.set('FIXED_WIN_FLUCS', 'Fixed Win Flucs');
  options.set('FIXED_PLACE', 'Fixed Place');
  options.set('FIXED_PLACE_FLUCS', 'Fixed Place Flucs');
  options.set('NONE', 'None');

  function handleSelect(e: Event) {
    const target = e.target as HTMLSelectElement;

    if (!layoutConfigStore || !$activeLayoutConfig) {
      // console.error('no layout config');
      return;
    }

    $activeLayoutConfig.remainingBookmakerSort;

    layoutConfigStore.updateOne({
      ...$activeLayoutConfig,
      //   @ts-expect-error this is typechecked above
      showRemainingBookmakers: target.value
    });
  }
</script>

<div>
  <label for="layouts" class="block text-sm font-medium leading-6 text-gray-900"
    >Show Remaining Bookmakers</label
  >
  <select
    on:change={handleSelect}
    id="layouts"
    name="layouts"
    class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
  >
    {#each [...options] as [key, value]}
      <option
        value={key}
        selected={key === $activeLayoutConfig?.showRemainingBookmakers}
        >{value}</option
      >
    {/each}
  </select>
</div>
